import React from 'react';

const Features = () => {
  const features = [
    {
      title: "Memorable Brand",
      description: "Short, unique, and easy to remember - perfect for global branding"
    },
    {
      title: "Versatile Usage",
      description: "Ideal for AI, tech, or innovative digital products"
    },
    {
      title: "Global Appeal",
      description: "Strong potential for international markets"
    }
  ];

  return (
    <section id="features" className="features">
      <h2>Domain Potential</h2>
      <div className="feature-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features; 